module.exports = __webpack_public_path__ + "static/media/kernelcon_white.c552b7f7.png";